import React, {Component} from "react";
import {connect} from "react-redux";
import {citationFetchData} from "../../../actions/citation";
import {BrowserRouter as Router, Link} from 'react-router-dom'



class EpaDossier extends Component {

    state = {
        url: 'theoretical'
    }

    componentDidMount() {
        this.props.fetchData(`https://psytable-api.herokuapp.com/api/citation/${this.state.url}`);
    }

    componentDidUpdate(prevProps, prevState, snapshot){

        if (this.state.url !== prevState.url){
            this.props.fetchData(`https://psytable-api.herokuapp.com/api/citation/${this.state.url}`);
        }


    }
    onChoseItem = (e) => {
        //add active class
        document.querySelector('.dossier__category-item.active').classList.remove('active')
        e.target.classList.add('active')


        this.setState({
            url: e.target.getAttribute('data-item')
        })


    }

    render() {
        return (
            <section className="dossier">
                <div className="dossier__inner">
                    <div className="dossier__table">
                        <div className="dossier__table-left">
                            <ul className="dossier__category-list">
                                <li className="dossier__category-item active" data-item="theoretical"
                                    onClick={this.onChoseItem}>Theoretical
                                </li>
                                <li className="dossier__category-item" data-item="psychological"
                                    onClick={this.onChoseItem}>Psychological
                                </li>
                                <li className="dossier__category-item" data-item="medical"
                                    onClick={this.onChoseItem}>Medical
                                </li>
                                <li className="dossier__category-item" data-item="physiological"
                                    onClick={this.onChoseItem}>Physiological
                                </li>
                                <li className="dossier__category-item" data-item="crossCultural"
                                    onClick={this.onChoseItem}>Cross-Cultural
                                </li>
                                <li className="dossier__category-item" data-item="genetic"
                                    onClick={this.onChoseItem}>Genetic
                                </li>
                                <li className="dossier__category-item" data-item="phylogenetic"
                                    onClick={this.onChoseItem}>Phylogenetic
                                </li>
                                <li className="dossier__category-item" data-item="hunterGatherer"
                                    onClick={this.onChoseItem}>Hunter-Gatherer
                                </li>
                            </ul>
                            <div className="dossier__total-score">
                                <span>Epa Total Score:</span>
                            </div>
                        </div>
                        <div className="dossier__table-right">
                            <div className="dossier-headline">
                                <span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A accusamus ad dicta explicabo, facilis libero maxime necessitatibus, nemo neque nesciunt nostrum numquam obcaecati omnis perspiciatis quam recusandae rerum similique ut.</span>
                            </div>

                            <ul className="citation">
                                {
                                    this.props.citation.map((item, index) => {
                                        if (item.parentEpa === this.props.epaId.trim()) {
                                            return (
                                                <li className="citation__item" key={index}>
                                                    <Router>
                                                        <Link to={`/citation/${this.state.url}/${item._id}`}
                                                              target="_parent" className="citation__link">
                                                            {item.abstract}
                                                        </Link>

                                                    </Router>
                                                    <div className="citation__score">
                                                        <span className="citation__score-support">
                                                            Score Support
                                                        </span>
                                                        <span className="citation__score-challenge">
                                                            Score Challenge
                                                        </span>
                                                        <span className="citation__score-submitted">
                                                            Submitted by
                                                        </span>
                                                    </div>
                                                </li>
                                            )
                                        }
                                    })

                                }

                            </ul>
                            <div className="dossier__theoretical-score">
                                <span>Theoretical Score:</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        citation: state.citation,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        fetchData: url => dispatch(citationFetchData(url)),

    };
}


export default connect(mapStateToProps, mapDispatchToProps)(EpaDossier);
